import './BoardInfo.scss'

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'react-fa'
import ReactModal from 'react-modal'
import BoardInfoLaneDescription from './BoardInfoLaneDescription'
import { ModalStyle } from '../../constants/modalConfig'
import { GAEventTracker, CAT_UI_ACTION, ACTION_LANE_HELP_OPENED } from '../../util/googleAnalytics'
import CloseModalButton from '../CloseModalButton'
import HelpLink from '../HelpLink'
import { TOPIC_CUSTOM_BOARDS } from '../../constants/boardsHelpTopics'

class BoardInfo extends React.Component {
  constructor(props) {
    super(props)
    this.gaEventTracker = new GAEventTracker(ga)
    this.state = {
      modalOpen: false
    }
  }

  handleOnOpen = () => {
    this.gaEventTracker.trackEvent(CAT_UI_ACTION, ACTION_LANE_HELP_OPENED)
    this.setState({
      modalOpen: true
    })
  }

  handleOnClose = () => {
    this.setState({
      modalOpen: false
    })
  }

  render() {
    let { localize } = this.props
    const customBoardsMessage = '*' + localize('taskBoards.Msg_CustomBoardsHowTo')
    const customBoardsLinkText = localize('taskBoards.Text_CustomBoardsHelpLinkText')
    const customBoardsHelpInfo = (
      <div className='custom-boards-info-message'>
        {customBoardsMessage} <HelpLink helpTopic={TOPIC_CUSTOM_BOARDS}>{customBoardsLinkText}</HelpLink>
      </div>)

    return (
      <div className={`board-help-button ${this.props.className}`}>
        <Icon name='info-circle' onClick={this.handleOnOpen} />
        <ReactModal
          isOpen={this.state.modalOpen}
          style={ModalStyle}
          contentLabel={`Help for board type ${this.props.boardDef.name}`}
          onRequestClose={this.handleOnClose}
          ariaHideApp={false}
        >
          <div className='board-help-modal-header'>
            <div className='board-help-modal-header-title'>{this.props.boardDef.name}</div>
            <CloseModalButton onClose={this.handleOnClose} />
          </div>
          <div className='board-help-modal-body'>
            <div key='header' className='lane-help-entry header'>
              <div className='lane-help-lane-name'>{localize('taskBoards.Label_LaneName')}</div>
              <div className='lane-help-lane-description'>{localize('common.Label_Description')}</div>
            </div>
            <div>
              {this.props.boardDef.swimlanes.map((lane) => {
                return (<BoardInfoLaneDescription localize={localize} key={lane.id} name={lane.name} mapping={lane.mapping} />)
              })}
            </div>
          </div>
          <div className='board-help-modal-footer'>
            {customBoardsHelpInfo}
          </div>
        </ReactModal>
      </div>
    )
  }
}

BoardInfo.propTypes = {
  boardDef: PropTypes.object.isRequired,
  className: PropTypes.string,
  localize: PropTypes.func
}

export default BoardInfo



// WEBPACK FOOTER //
// ./src/components/BoardInfo/BoardInfo.js